import Vue from "vue";
import * as servers from "../api/servers";

export default {
  state: {
    server: {},
    servers: [],
    providers: [],
    provider: {},
    serverHealths: {},
    serverProvider: []
  },
  getters: {
    getServerHealth: state => index => state.serverHealths[index]
  },
  mutations: {
    getServers(state, servers) {
      state.servers = servers;
    },
    getServer(state, server) {
      state.server = server;
    },
    getProviders(state, providers) {
      state.providers = providers;
    },
    getServerHealth(state, { id, healths }) {
      Vue.set(state.serverHealths, `server-${id}`, healths);
    },
    getServerInProvider(state, serverProvider) {
      state.serverProvider = serverProvider;
    }
  },
  actions: {
    async getServers({ commit, dispatch }) {
      const data = await servers.getServers();
      data.map(server => dispatch("getServerHealth", { id: server.id }));
      commit("getServers", data);
    },
    async getServer({ commit }, id) {
      commit("getServer", await servers.getServer(id));
    },
    async createServer({ dispatch }, server) {
      try {
        const response = await servers.createServer(server);
        dispatch("getServers");
        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          case "SequelizeUniqueConstraintError":
            dispatch("setToastMessage", { message: "ipExist" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async updateServer({ dispatch }, { id, server }) {
      const response = await servers.updateServer(id, server);
      dispatch("getServers");
      dispatch("getServer", id);
      return response;
    },
    async deleteServer({ dispatch }, { id }) {
      try {
        const response = await servers.deleteServer(id);
        dispatch("getServers");
        return response;
      } catch (error) {
        return { success: false };
      }
    },
    async getProviders({ commit }) {
      commit("getProviders", await servers.getProviders());
    },
    async getServerInProvider({ commit }, id) {
      const data = await servers.getServerInProvider(id);
      commit("getServerInProvider", data);
    },
    async addUserToServer({ dispatch }, { id, email }) {
      const response = await servers.addUser(id, email);
      dispatch("getServers");
      dispatch("getServer", id);
      return response;
    },
    async removeUserFromServer({ dispatch }, { id, email }) {
      const response = await servers.removeUser(id, email);
      dispatch("getServers");
      dispatch("getServer", id);
      return response;
    },
    async getServerHealth({ commit }, { id, scale, time }) {
      if (!scale) scale = "day";
      if (!time) time = 2;
      commit("getServerHealth", {
        id,
        healths: await servers.getHealth(id, scale, time)
      });
    }
  }
};
